module.exports = __webpack_public_path__ + "img/add-emoji.f4300943.svg";